module.exports = __webpack_public_path__ + "img/album17_12.51616b78.jpg";